export default __webpack_public_path__ + "static/Blair-28806d46c67bef2a6ab97e5709c974a3cbdcefe29670c1710dd2753ae27814ee.svg";